if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.previousButton = this.querySelector('[data-product-modal-previous]');
        this.nextButton = this.querySelector('[data-product-modal-next]');

        this.previousButton?.addEventListener('click', this.onPreviousButtonClick.bind(this));
        this.nextButton?.addEventListener('click', this.onNextButtonClick.bind(this));
        this.previousButton?.addEventListener('pointerup', (event) => event.stopPropagation());
        this.nextButton?.addEventListener('pointerup', (event) => event.stopPropagation());
        this.addEventListener('keydown', this.onKeyDown.bind(this));
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      getMediaItems() {
        return Array.from(this.querySelectorAll('.product-media-modal__content > [data-media-id]'));
      }

      getActiveMediaIndex() {
        return this.getMediaItems().findIndex((element) => element.classList.contains('active'));
      }

      onPreviousButtonClick(event) {
        event.preventDefault();
        this.showAdjacentMedia(-1);
      }

      onNextButtonClick(event) {
        event.preventDefault();
        this.showAdjacentMedia(1);
      }

      onKeyDown(event) {
        if (!this.hasAttribute('open')) return;
        if (event.code === 'ArrowLeft') {
          event.preventDefault();
          this.showAdjacentMedia(-1);
        }
        if (event.code === 'ArrowRight') {
          event.preventDefault();
          this.showAdjacentMedia(1);
        }
      }

      showAdjacentMedia(direction) {
        const mediaItems = this.getMediaItems();
        if (mediaItems.length <= 1) return;

        const activeIndex = this.getActiveMediaIndex();
        const nextIndex = (activeIndex + direction + mediaItems.length) % mediaItems.length;
        this.setActiveMedia(mediaItems[nextIndex]);
      }

      setActiveMedia(activeMedia) {
        if (!activeMedia) return;

        this.getMediaItems().forEach((element) => {
          element.classList.toggle('active', element === activeMedia);
        });

        const container = this.querySelector('[role="document"]');
        if (container) {
          container.scrollTop = 0;
          container.scrollLeft = 0;
        }

        this.updateSliderControls();
        this.loadActiveDeferredMedia(activeMedia);
      }

      updateSliderControls() {
        const mediaItems = this.getMediaItems();
        const hasMultipleSlides = mediaItems.length > 1;
        [this.previousButton, this.nextButton].forEach((button) => {
          if (!button) return;
          button.hidden = !hasMultipleSlides;
          button.disabled = !hasMultipleSlides;
          button.setAttribute('aria-hidden', hasMultipleSlides ? 'false' : 'true');
        });
      }

      loadActiveDeferredMedia(activeMedia) {
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }

      showActiveMedia() {
        const openedMediaId = this.openedBy.getAttribute('data-media-id');
        const activeMedia = this.querySelector(
          `.product-media-modal__content > [data-media-id="${openedMediaId}"]`
        );
        this.setActiveMedia(activeMedia || this.getMediaItems()[0]);
      }
    }
  );
}
